module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/bonds-small.RU.b9467749.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/bonds-small.RU.png
// module id = 2668
// module chunks = 11